module.exports = __webpack_public_path__ + "img/LV6.8a0be7fa.webp";